import React from 'react';

const DataAugmentationPage: React.FC = () => {
  return (
    <div className="default-page-view">
      <h1>Data Augmentation</h1>
      <p className="description">
        This feature is coming soon! Stay tuned for updates.
      </p>
    </div>
  );
};

export default DataAugmentationPage; 